module.exports = __webpack_public_path__ + "img/bg-download-section-2.2f4c1c31.jpg";